export { default } from './PrivacyNoticeLink';
